import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, unref as _unref, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b913cb4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "condition-criteria__input" };
const _hoisted_2 = ["title", "placeholder"];
const _hoisted_3 = { class: "no-click condition-criteria__list-wrapper" };
const _hoisted_4 = { class: "no-click condition-criteria__list" };
const _hoisted_5 = {
    key: 0,
    class: "customScrollBar no-click condition-criteria__list-groups"
};
const _hoisted_6 = { class: "condition-criteria__list__group-title" };
const _hoisted_7 = {
    key: 0,
    class: "condition-criteria__list-items"
};
const _hoisted_8 = ["innerHTML", "title", "onClick"];
const _hoisted_9 = {
    key: 1,
    class: "condition-criteria__empty"
};
import { ref, computed, watch, inject } from 'vue';
import { useStore } from 'vuex';
import { stringParser } from '@/helpers/string-parser.js';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
import { useClickOutside } from '@/features/AudienceManager/composables/useClickOutside';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConditionCriteria',
    setup(__props) {
        const store = useStore();
        const groupIndex = inject('groupIndex');
        const isInclude = inject('isInclude');
        const groupType = inject('groupType');
        const { draftCondition, allCriteriaOptions, keepFooterLoadingDuringInteraction } = useAudienceManager(isInclude, groupIndex);
        const dropdownRef = ref(null);
        const searchTerm = ref('');
        const { isDropdownOpen } = useClickOutside(dropdownRef, () => {
            setDropdownVisibility(false);
        });
        const filteredCriteria = computed(() => {
            const term = stringParser(searchTerm.value.trim().toLowerCase());
            if (!term)
                return allCriteriaOptions.value;
            return allCriteriaOptions.value
                .map(categoryCriteria => filterCriteriaBySearch(categoryCriteria, term))
                .filter(Boolean);
        });
        const filterCriteriaBySearch = (criteriaCategory, searchTerm) => {
            const filteredCriteria = criteriaCategory.columns.filter(criteria => stringParser(criteria.name).toLowerCase().includes(searchTerm));
            const result = { key: criteriaCategory.key, columns: filteredCriteria };
            return filteredCriteria.length ? result : null;
        };
        const currentCriteriaNameByKey = computed(() => {
            let criteriaName = '';
            if (draftCondition?.value?.column) {
                allCriteriaOptions.value.forEach(groupsOptions => {
                    const criteria = groupsOptions.columns.find(col => col.key === draftCondition.value.column);
                    if (criteria)
                        criteriaName = criteria.name;
                });
            }
            return criteriaName;
        });
        const updateDraftCondition = (data) => {
            store.dispatch('audienceManager/updateDraftCondition', {
                groupIndex,
                groupType,
                data,
            });
        };
        const selectCriteriaOption = (criteria) => {
            searchTerm.value = criteria.name;
            setDropdownVisibility(false);
            updateSelectedCriteria(criteria.key);
            keepFooterLoadingDuringInteraction();
            store.commit('audienceManager/UPDATE_ACTIVE_GROUP_INDEX', groupIndex);
            updateDraftCondition({
                column: criteria.key,
                operator: criteria.operators?.[0] || 'equal',
            });
        };
        const clearCriteriaSelection = () => {
            searchTerm.value = '';
            updateDraftCondition({
                column: '',
                operator: '',
                value: [],
                referenceObjects: {},
                f_operator: '',
                f_value: [],
                f_type: '',
            });
            updateSelectedCriteria(null);
            setDropdownVisibility(true);
            store.commit('audienceManager/SET_CONDITION_VALIDITY', {
                groupType,
                groupIndex,
                isValid: true,
            });
        };
        const resetInvalidSearch = () => {
            setTimeout(() => {
                if (searchTerm.value !== currentCriteriaNameByKey.value) {
                    searchTerm.value = '';
                    updateSelectedCriteria(null);
                }
            }, 500);
        };
        const updateSelectedCriteria = (criteriaKey) => {
            updateDraftCondition({
                referenceObjects: {},
            });
            store.dispatch('audienceManager/updateSelectedCriteria', {
                criteriaKey,
                groupType,
                groupIndex,
            });
        };
        const setDropdownVisibility = (isVisible) => {
            isDropdownOpen.value = isVisible;
            keepFooterLoadingDuringInteraction();
        };
        watch(() => draftCondition.value?.column, newCriteria => {
            if (newCriteria) {
                searchTerm.value = currentCriteriaNameByKey.value;
            }
            else {
                searchTerm.value = '';
            }
        }, { deep: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "dropdownRef",
                ref: dropdownRef,
                class: "condition-criteria"
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchTerm).value = $event)),
                        type: "text",
                        class: "no-click",
                        title: searchTerm.value,
                        placeholder: _ctx.$t('select'),
                        autocomplete: "off",
                        onFocus: _cache[1] || (_cache[1] = ($event) => (setDropdownVisibility(true))),
                        onClick: _cache[2] || (_cache[2] = ($event) => (setDropdownVisibility(true))),
                        onBlur: resetInvalidSearch,
                        onInput: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_unref(keepFooterLoadingDuringInteraction) && _unref(keepFooterLoadingDuringInteraction)(...args)))
                    }, null, 40, _hoisted_2), [
                        [_vModelText, searchTerm.value]
                    ]),
                    (searchTerm.value.length)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "icon icon-close",
                            "data-clear-input": "",
                            onClick: clearCriteriaSelection
                        }))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: _normalizeClass(`icon icon-${_unref(isDropdownOpen) ? 'search' : 'select-12px'}`)
                        }, null, 2))
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        (filteredCriteria.value.length > 0)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCriteria.value, (categoryCriteria) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: categoryCriteria.key,
                                        class: "no-click condition-criteria__list-group"
                                    }, [
                                        _createElementVNode("strong", _hoisted_6, _toDisplayString(categoryCriteria.key), 1),
                                        (categoryCriteria.columns.length > 0)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryCriteria.columns, (criteria) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        innerHTML: criteria.name,
                                                        key: criteria.key,
                                                        title: criteria.name,
                                                        class: "no-click condition-criteria__list-item",
                                                        onClick: ($event) => (selectCriteriaOption(criteria)),
                                                        onMouseover: _cache[4] || (_cache[4] =
                                                            //@ts-ignore
                                                            (...args) => (_unref(keepFooterLoadingDuringInteraction) && _unref(keepFooterLoadingDuringInteraction)(...args)))
                                                    }, null, 40, _hoisted_8));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('audiences.no-results')), 1))
                    ])
                ], 512), [
                    [_vShow, _unref(isDropdownOpen)]
                ])
            ], 512));
        };
    }
});
